export const AgreementKey = 'fe_c_agreement';
export const SmsCountdown = 'fe_c_sms_countdown';
